import {API, Setup} from '../../Services';


async function BlogList_api(tagId=null){
    let mallId =  localStorage.getItem('mallId');
    // let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_posts`,{
        // headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            post_type:'blog_post',
            tag__uid:tagId
            // is_introduction:false
        }
    });
}


export {BlogList_api};
